import { createComponent, createHook } from 'reakit-system';
import { ComponentPropsWithRef } from 'react';
import { CheckerIconOptions, useCheckerIcon } from './useCheckerIcon';
import { BoxOptions, useBox } from '../../Box/Box';
import { useStyles } from '../useStyles';

type CheckablesWrapperOptions = CheckerIconOptions & BoxOptions;

const useCheckablesLabel = createHook<
  CheckablesWrapperOptions,
  ComponentPropsWithRef<'label'>
>({
  name: 'useCheckablesWrapper',
  compose: [useBox, useStyles, useCheckerIcon],
  keys: ['kind', 'disabled'],
  useOptions(options) {
    return {
      display: 'flex',
      maxWidth: 1,
      ...options,
    };
  },
});

export const CheckablesLabel = createComponent({
  useHook: useCheckablesLabel,
  as: 'label',
});
